/**
 * webhooks-crud
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.1.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import { Step } from "./step";

export enum RestrictedFeatures {
  CLONE = 'clone',
  EDIT = 'edit',
  REMOVE = 'remove',
  TOGGLE = 'toggle',
}

/**
 * The definition of the playbook
 */
export interface Playbook {
  /**
   * (PRIMARY KEY) a random UUID identifies this playbook flow
   */
  playbook_id?: string;
  /**
   * The title of the playbook flow
   */
  playbook_title?: string;
  /**
   * The description of the playbook flow
   */
  playbook_description?: string;
  /**
   * The email of the playbook creator
   */
  created_by?: string;
  /**
   * The timestamp this playbook was created
   */
  creation_timestamp?: Date;
  /**
   * The email of the last playbook editor
   */
  last_updated_by?: string;
  /**
   * The timestamp this playbook was last updated
   */
  last_update_timestamp?: Date;
  /**
   * Whether the playbook is active or disabled
   */
  active?: boolean;
  /**
   * Playbook steps
   */
  steps?: Step[]
  /**
   * A list of features that are disabled for this playbook
   */
  restricted_features?: RestrictedFeatures[];
}

export interface Automation {
  automation_id: string;
  created_by: string;
  trigger_name: string;
  action_name: string;
  active: boolean;
  restricted_features?: RestrictedFeatures[];
}
